
import type { PropType } from 'vue'

import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        tabs: {
            type: Array as PropType<Array<{ id: string; name: string }>>,
            default: () => []
        },
        value: {
            type: [String, null] as PropType<string | null>,
            default: null
        },
    },
    emits: ['change'],
    setup(props, { emit }) {
        const isTabSelected = (tab: { id: string; name: string }) => {
            if (!props.value) return false
            return props.value === tab.id
        }

        const onSelectTab = (tab: { id: string; name: string }) => {
            if (isTabSelected(tab)) return
            emit('change', tab.id)
        }

        return {
            isTabSelected,
            onSelectTab
        }
    }
})
